import React from 'react'
import { HightLight, Text } from '../gameRulesStyle'

export default function Elements() {
  return (
    <>
      <HightLight fontSize='22px' background='green' margin={'30px 0 0'}>
        {' '}
        Elements
      </HightLight>
      <Text margin={'15px 0'}>
        CYBERDICE HAS ITS OWN COLOR DEPENDENCIES ON DIFFERENT GAME MODES AND
        CONFIGURATIONS
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='blue'>
          Blue
        </HightLight>{' '}
        - GENERALLY REFERS TO ROLL OVER and in additional use for UI
        VISUALIZATION.
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='red'>
          Red
        </HightLight>{' '}
        - GENERALLY REFERS TO ROLL UNDER and in additional use for UI
        VISUALIZATION.
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='green'>
          Green
        </HightLight>{' '}
        - GENERALLY REFERS TO WIN GAME and in additional use for UI
        VISUALIZATION.
      </Text>
      <Text margin={'0px 0 15px'}>
        <HightLight fontSize='18px' background='grey'>
          Grey
        </HightLight>{' '}
        - GENERALLY REFERS TO LOSS GAME and in additional use for UI
        VISUALIZATION.
      </Text>
    </>
  )
}
